import { useQuery } from '@tanstack/react-query'
import { ProtocolEnrollment } from '../types/protocol'
import { protocolService } from '../services/protocolService'
import { format } from 'date-fns'
import './PatientProtocolList.css'

interface PatientProtocolListProps {
  patientId: string
  onEnroll?: () => void
  onExclude?: (enrollment: ProtocolEnrollment) => void
}

export function PatientProtocolList({ patientId, onEnroll, onExclude }: PatientProtocolListProps) {
  const { data: enrollments, isLoading, error } = useQuery<ProtocolEnrollment[]>({
    queryKey: ['patient-protocols', patientId],
    queryFn: () => protocolService.getPatientProtocols(patientId),
  })

  if (isLoading) return <div className="patient-protocol-list-loading">Loading protocols...</div>
  if (error) return <div className="patient-protocol-list-error">Error loading protocols</div>
  if (!enrollments || enrollments.length === 0) {
    return (
      <div className="patient-protocol-list-empty">
        <p>No protocol enrollments found</p>
        <button className="btn-primary" onClick={onEnroll}>
          Check Eligibility
        </button>
      </div>
    )
  }

  return (
    <div className="patient-protocol-list">
      {enrollments.map((enrollment) => (
        <div key={enrollment.id} className="protocol-enrollment-item">
          <div className="enrollment-header">
            <div className="enrollment-info">
              <div className="enrollment-protocol-name">{enrollment.protocolId}</div>
              <div className="enrollment-date">
                Enrolled: {format(new Date(enrollment.enrolledAt), 'MMM dd, yyyy')}
              </div>
            </div>
            <div className="enrollment-status">
              <span className={`status-badge status-${enrollment.status}`}>{enrollment.status}</span>
            </div>
          </div>
          {enrollment.excludedAt && (
            <div className="enrollment-exclusion">
              Excluded: {format(new Date(enrollment.excludedAt), 'MMM dd, yyyy')}
              {enrollment.excludedReason && <span> - {enrollment.excludedReason}</span>}
            </div>
          )}
          {enrollment.status === 'enrolled' && onExclude && (
            <div className="enrollment-actions">
              <button className="btn-danger btn-sm" onClick={() => onExclude(enrollment)}>
                Exclude
              </button>
            </div>
          )}
        </div>
      ))}
      <div className="protocol-list-actions">
        <button className="btn-primary" onClick={onEnroll}>
          Check Eligibility for More Protocols
        </button>
      </div>
    </div>
  )
}
